import FormPage, { FormPageTop } from '@chegg-wt/core/components/Layouts/Form'
import { NextPageWithLayout } from '@chegg-wt/core/types/layout'
import { getLvpLayout } from '@chegg-wt/core/components/Layouts/LargeVideoPlayerLayout'
import React from 'react'

import { useRouter } from 'next/router'
import SEOTitle from '@chegg-wt/core/components/SEOTitle'
import { useRoutesContext } from '@chegg-wt/core/components/RoutesContext'
import useUserRole from '@chegg-wt/core/hooks/useUserRole'
import useRedirect from '@chegg-wt/core/hooks/useRedirect'
import {
  SESSION_STORAGE_KEYS,
  getSessionStorageItem,
} from '@chegg-wt/core/utils/sessionStorage'
import { UserRoles } from '@chegg-wt/core/constants/user'
import { getSourceTypeName, sourceTypeById } from '@chegg-wt/core/utils/sourceTypes'
import {
  getCapitalizedSEONameOfStyle,
  isStyleIdInValid,
} from '@chegg-wt/core/utils/styles'
import { useOnUnloadTimeOnPage } from '@chegg/time-on-page'
import { NextPageContext } from 'next'
import { formB1 } from '../../../copy/CMSContent'
import { getSourceFromQuery, getStyleFromQuery } from '../../../utils/routes'

const CustomPage: NextPageWithLayout = () => {
  const userRole = useUserRole()
  const { toDashboard } = useRoutesContext()
  const hasSessionData = !!getSessionStorageItem(SESSION_STORAGE_KEYS.formData)
  useRedirect({
    shouldRedirect: userRole === UserRoles.PRO_USER && !hasSessionData,
    redirectRoute: toDashboard(),
  })
  const router = useRouter()
  const { style: styleQuery, source: sourceQuery } = router.query as {
    style: string
    source: string
  }
  const source = getSourceFromQuery(router, sourceQuery)
  const style = getStyleFromQuery(router, styleQuery, false)
  const formattedStyle = getCapitalizedSEONameOfStyle(style)

  useOnUnloadTimeOnPage()
  return (
    <>
      <SEOTitle
        title={`Citation Form | ${formattedStyle} | ${getSourceTypeName(
          source
        )} | EasyBib`}
      />
      <FormPage route="toManualCitation" formType="manual" copy={formB1} />
    </>
  )
}

export const getServerSideProps = async ({ query }: NextPageContext) => {
  const { style, source: sourceQuery } = query as { style: string; source: string }
  const source = getSourceFromQuery({ route: '/[style]/[source]/custom' }, sourceQuery)
  return {
    props: {},
    notFound: isStyleIdInValid(style) || !sourceTypeById(source),
  }
}

CustomPage.getPageLayout = (page) => getLvpLayout(page, () => <FormPageTop />)

export default CustomPage
